import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
// components
import AffiliatedPrices from "../../molecules/affiliated-prices/affiliatedPrices";
import TitleSection from "../../molecules/title-section";
// styles
import "./priceInformation.scss";

const PriceInformation = (props: ReferenciaContenido) => {

    return (
        <div className="o-priceInformation__details-container">
            <div className="o-priceInformation__details-mainSection">
                <div className="o-priceInformation__details-affiliatedPrices">
                    <TitleSection title={props.tituloGeneral} />
                    {props.referenciaPlantillaContenido.map((elem, i) => (
                        <AffiliatedPrices
                            key={`price${i}`}
                            tarifa={elem.tituloBanner}
                            ahorra={elem.tituloBoton}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PriceInformation;
